import React, { useEffect, useState } from 'react';
import { useAppActions, useAppState } from '../../../overmind';
import { FetchType } from '../../../enums';
import { PagePath } from '../../../navigation/navigation.enums';
import { useKeplerNavigate } from '../../../navigation/guards/use-kepler-navigate';
import { PageLoaderLayer } from '../../../components/general/loading-state/loader-layers/page-loader-layer/page-loader-layer';
import { EmptyState } from '../../../components/general/empty-state/empty-state';
import { PageHeader, Table, TableRow, TableColumn, KebabMenu, Anchor } from '@keplerco/core';
import { AgentTypeDto } from '../../../overmind/actions';

export function AgentsPage(): JSX.Element {
  const keplerNavigate = useKeplerNavigate();

  const actions = useAppActions();
  const { companyVariables } = useAppState();

  const [agentTypes, setAgentTypes] = useState<AgentTypeDto[]>();

  useEffect(() => {
    async function getData() {
      actions.startLoader({ path: PagePath.aiManagementAgents, type: FetchType.PageFetching });

      const agentTypes = await actions.getAgentTypes();
      setAgentTypes(agentTypes);

      actions.stopLoader(PagePath.aiManagementAgents);
    }

    getData();
  }, [companyVariables.slug]);

  function navigateToEditAgent(agentTypeName: string) {
    keplerNavigate(`${PagePath.aiManagementBase}${PagePath.aiManagementAgent.replace(':agentTypeName', agentTypeName).replace(':companySlug', companyVariables.slug!)}`);
  }

  return (
    <PageLoaderLayer path={PagePath.aiManagementAgents}>
      <div className="wrapper stack" style={{ gap: 24 }}>
        <PageHeader
          breadcrumbs={[
            { name: 'AI Management', url: PagePath.aiManagementBase },
            { name: 'Agents', url: location.pathname },
          ]}
          title="Agents"
          subtitle="Manage AI agents and their prompts"
          divider
        />

        <Table standAloneConfigColumn emptyState={<EmptyState title="No agent types found" />}>
          {agentTypes?.map(agentType => (
            <TableRow
              key={agentType.name}
              id={agentType.name}
              configCell={() => (
                <KebabMenu
                  items={[
                    {
                      label: 'Edit',
                      onClick: () => navigateToEditAgent(agentType.name),
                    },
                  ]}
                />
              )}
            >
              <TableColumn id="name" label="Name">
                <Anchor hovertype="opacity" textTransform="none" onClick={() => navigateToEditAgent(agentType.name)}>
                  {agentType.displayName}
                </Anchor>
              </TableColumn>

              <TableColumn id="description" label="Description">
                {agentType.description}
              </TableColumn>
            </TableRow>
          ))}
        </Table>
      </div>
    </PageLoaderLayer>
  );
}
